import { ProductAvailability } from '@types';

export const shoppingCartDemo = {
    orderNumber: 'anc564645',
    total: {
        productsValue: 10.99,
        promotion: {
            discount: -5,
            eligibleItems: ['A', 'B', 'C'],
        },
        subtotal: 5.99,
        shipping: 0,
        total: 5.99,
        points: 7,
        products: [
            /* cspell:disable */
            { name: 'Sapatos de mulher', image: 'https://picsum.photos/126/300', price: 17.75, quantity: 1 },
            { name: 'Sapatos de criança', image: 'https://picsum.photos/126/300', price: 15.99, quantity: 2 },
            { name: 'Camisola riscada', image: 'https://picsum.photos/126/300', price: 12.99, quantity: 1 },
            /* cspell:enable */
        ],
        nProducts: 4,
    },
    productsByMerchant: [
        /* cspell:disable */
        {
            merchant: 'Roma Sapatarias',
            products: [
                {
                    uuid: '',
                    name: 'Sapato de mulher',
                    image: 'https://picsum.photos/126/300',
                    price: 17.5,
                    quantity: 1,
                    availability: ProductAvailability.inStock,
                },
                {
                    uuid: '',
                    name: 'Sapato de criança',
                    image: 'https://picsum.photos/126/300',
                    price: 17.5,
                    quantity: 1,
                    availability: ProductAvailability.inStock,
                },
            ],
        },
        {
            merchant: 'Mercearia do Bairro',
            products: [
                {
                    uuid: '',
                    name: 'Azeite Virgem Extra',
                    image: 'https://picsum.photos/126/300',
                    price: 8.15,
                    quantity: 1,
                    availability: ProductAvailability.inStock,
                },
            ],
        },
        /* cspell:enable */
    ],
};
